import { render, staticRenderFns } from "./Service1024.vue?vue&type=template&id=73277e8d&scoped=true"
import script from "./Service1024.vue?vue&type=script&lang=js"
export * from "./Service1024.vue?vue&type=script&lang=js"
import style0 from "./Service1024.vue?vue&type=style&index=0&id=73277e8d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73277e8d",
  null
  
)

export default component.exports